import { EnvironmentProviders } from '@angular/core';
import { environment } from '@environment/environment';
import { provideMatomo, withRouter } from 'ngx-matomo-client';

export const provideMatomoAnalytics = (): EnvironmentProviders[] => {
  if (!environment.matomo.enabled) {
    return [];
  }

  return [
    provideMatomo(
      {
        siteId: environment.matomo.siteId,
        trackerUrl: environment.matomo.trackerUrl,
        requireConsent: 'none'
      },
      withRouter({
        exclude: ['/login', /\/preview\//]
      })
    )
  ];
}
